import { batch, useDispatch } from 'react-redux';
import { getShopifyCIEMList } from '../reducers/shopify_api/ShopifyCIEMSlice';
import allActions from '../actions/product_builder';
import { useEffect, useState } from 'react';
import { sortModelsByPrice } from '../App';
import { unwrapResult } from '@reduxjs/toolkit';
const FetchInitialData = ({ iems, model, configid }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    // const shopifyCIEMList = useSelector((state) => state.shopifyReducer.ciems).length;
    let pickedModel = iems?.find((option) => {
        return option.name === model;
    });
    if (!pickedModel) {
        pickedModel = iems?.find((option) => option.name === 'A6t');
    }
    useEffect(() => {
        dispatch(getShopifyCIEMList())
            .then(unwrapResult)
            .then((result) => {
                if (configid && iems) {
                    dispatch(
                        allActions.modelActions.setListOfModels(sortModelsByPrice(iems, result))
                    );
                    dispatch(allActions.categoryActions.setActiveCategory('Summary'));
                    setIsLoading(false);
                } else if (pickedModel && iems) {
                    let sortedModelList = [];
                    const currentShopifyProduct = result.find(
                        (product) => product.title === pickedModel.name
                    );
                    sortedModelList = sortModelsByPrice(iems, result);
                    const currentModelPOS = sortedModelList.findIndex(
                        (currModel) => currModel.name === pickedModel.name
                    );
                    batch(() => {
                        dispatch(allActions.modelActions.setListOfModels(sortedModelList));
                        dispatch(allActions.modelActions.setCurrentModel(pickedModel));
                        dispatch(allActions.modelActions.setCurrentPOS(currentModelPOS));
                        dispatch(allActions.categoryActions.setActiveCategory('Model'));
                        dispatch(
                            allActions.shellActions.setActiveShell(
                                pickedModel.default_options.shell
                            )
                        );
                        dispatch(
                            allActions.faceplateActions.setActiveFaceplateOption(
                                pickedModel.default_options.faceplate
                            )
                        );
                        dispatch(
                            allActions.artworkActions.setActiveArtwork(
                                pickedModel.default_options.artwork
                            )
                        );
                        dispatch(
                            allActions.cableActions.setActiveCable(
                                pickedModel.default_options.cable
                            )
                        );

                        dispatch(
                            allActions.priceActions.setIEMPrice({
                                iem: pickedModel,
                                shopify: currentShopifyProduct
                            })
                        );
                        dispatch(allActions.categoryActions.updateSummaryCategory(false));
                        setIsLoading(false);
                    });
                }
            });
    }, [iems]);
    return { isLoading };
};

export default FetchInitialData;
